import '../../monitoring/filters/date/applied_date_view.js.coffee'

Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.AppliedSurveySentAtDateView extends Monitoring.Views.SocialContents.Filters.AppliedDateView

  fields:
    date_from_realtime: 'survey_sent_at_from_realtime'
    date_from: 'survey_sent_at_from'
    date_from_ISO: 'survey_sent_at_from_ISO'
    date_to: 'survey_sent_at_to'
    date_to_ISO: 'survey_sent_at_to_ISO'
    date_now: 'survey_sent_at_now'

  initialize: ({searchQuery, title}) ->
    super({searchQuery: searchQuery})
    @title = title || I18n.t('surveys.dashboard.filters.sent_at')
